module.exports = __webpack_public_path__ + "static/media/einvoice-reject.cda76734.svg";